import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Button, Card, Form } from "react-bootstrap";
import Dropzone from "react-dropzone";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";

function AlbumItems(props) {
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const AlbumRouteId = useParams();
  const [albumId, setAlbumId] = useState(
    Number(AlbumRouteId.AlbumRouteId) || 0
  );
  const [albumDetails, setAlbumSDetails] = useState({
    AlbumId: 0,
    AlbumName: "",
    IsPublished: false,
  });
  const [albumExist, setAlbumExist] = useState(null);
  const [items, setItems] = useState([]);
  const [loader, setLoader] = useState(false);
  const [DeleteModel, setDeleteModel] = useState(0);

  const [addLoader, setAddLoader] = useState(false);
  const [addModel, SetAddModel] = useState(false);
  const [addToDb, setAddToDb] = useState({
    AlbumItemId: 0,
    AlbumId: albumId,
    ImageUrl: "",
    Title: "",
    AltText: "",
  });

  const [updateLoader, setUpdateLoader] = useState(false);
  const [updateModel, SetUpdateModel] = useState(0);
  const [updateToDb, setUpdateToDb] = useState({
    AlbumItemId: 0,
    AlbumId: albumId,
    ImageUrl: "",
    Title: "",
    AltText: "",
  });

  const [image, setImage] = useState("");
  const [imageTodDb, setImageToDb] = useState("");

  const [deleteModal, setDeleteModal] = useState(0);

  // Get Album items
  const GetAlbumItems = async () => {
    setLoader(true);
    let response = await fetch(
      Variables.API_URL + "AlbumItem/GetAlbumItems/" + albumId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();

    if (response.status === 200) {
      setItems(result);
    } else {
    }
    setLoader(false);
  };

  // Get Album Details
  const GetAlbumDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "Album/GetAlbumById/" + albumId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();

    if (response.status === 200) {
      setAlbumSDetails(result);
    } else {
      setAlbumExist(false);
    }
  };

  // Check if Album exist
  const CheckIfAlbumExist = async () => {
    let response = await fetch(
      Variables.API_URL + "Album/CheckIfAlbumIdExist/" + albumId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();

    if (response.status === 200) {
      setAlbumExist(true);
      GetAlbumItems();
      GetAlbumDetails();
    } else {
      setAlbumExist(false);
    }
  };

  // handle Add Inputs
  function handleAddInputs(e) {
    const { name, value } = e.target;
    var element;
    if (name == "AddTitle") {
      if (value === "") {
        element = document.getElementById("AddTitle");
        element.classList.add("is-invalid");
      } else {
        element = document.getElementById("AddTitle");
        element.classList.remove("is-invalid");
      }
      setAddToDb((prevState) => ({
        ...prevState,
        ["Title"]: value,
      }));
    } else if (name == "AddAltText") {
      if (value === "") {
        element = document.getElementById("AddAltText");
        element.classList.add("is-invalid");
      } else {
        element = document.getElementById("AddAltText");
        element.classList.remove("is-invalid");
      }
      setAddToDb((prevState) => ({
        ...prevState,
        ["AltText"]: value,
      }));
    }
  }

  // handle Add Inputs
  function handleUpdateInputs(e) {
    const { name, value } = e.target;
    var element;
    if (name == "UpdateTitle") {
      if (value === "") {
        element = document.getElementById("UpdateTitle");
        element.classList.add("is-invalid");
      } else {
        element = document.getElementById("UpdateTitle");
        element.classList.remove("is-invalid");
      }
      setUpdateToDb((prevState) => ({
        ...prevState,
        ["Title"]: value,
      }));
    } else if (name == "UpdateAltText") {
      if (value === "") {
        element = document.getElementById("UpdateAltText");
        element.classList.add("is-invalid");
      } else {
        element = document.getElementById("UpdateAltText");
        element.classList.remove("is-invalid");
      }
      setUpdateToDb((prevState) => ({
        ...prevState,
        ["AltText"]: value,
      }));
    }
  }

  // Set update image
  const SetUpdateImage = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setImageToDb(x);
        setImage(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  // Set Add image
  const SetAddImage = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setImageToDb(x);
        setImage(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("ImageToAdd");
    element.classList.remove("is-invalid");
  };

  // Check input Add validity
  function IsValidToAdd() {
    var hasError = false;
    var element;
    if (addToDb.AltText === null || addToDb.AltText === "") {
      element = document.getElementById("AddAltText");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (addToDb.Title === null || addToDb.Title === "") {
      element = document.getElementById("AddTitle");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (imageTodDb === "") {
      element = document.getElementById("ImageToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }

    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Item
  const AddNewItem = async () => {
    setAddLoader(true);
    var valid = IsValidToAdd();
    if (valid) {
      let response = await fetch(Variables.API_URL + "AlbumItem/AddAlbumItem", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          AlbumItemId: addToDb.AlbumItemId,
          AlbumId: addToDb.AlbumId,
          ImageUrl: "",
          Title: addToDb.Title,
          AltText: addToDb.AltText,
        }),
      });
      let result = await response.json();
      if (response.status === 200) {
        const formData2 = new FormData();
        formData2.append("Image", imageTodDb);
        formData2.append("AlbumItemId", result);
        formData2.append("AlbumId", albumId);

        const resImage = await axios.post(
          Variables.API_URL + "AlbumItem/UploadAlbumItemImage",
          formData2,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );
        toast.success("Item Added Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setAddToDb({
          AlbumItemId: 0,
          AlbumId: albumId,
          ImageUrl: "",
          Title: "",
          AltText: "",
        });
        SetAddModel(false);
        setImage("");
        setImageToDb("");
        GetAlbumItems();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("please fill all required fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    setAddLoader(false);
  };

  // Delete Item
  const DeleteItem = async (Id) => {
    let response = await fetch(
      Variables.API_URL + "AlbumItem/DeleteAlbumItem/" + Id,
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setDeleteModal(0);
      SetUpdateModel(0);
      GetAlbumItems();
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // Check input update validity
  function IsValidToUpdate() {
    var hasError = false;
    var element;
    if (updateToDb.AltText === null || updateToDb.AltText === "") {
      element = document.getElementById("UpdateAltText");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (updateToDb.Title === null || updateToDb.Title === "") {
      element = document.getElementById("UpdateTitle");
      element.classList.add("is-invalid");
      hasError = true;
    }

    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Item
  const UpdateItem = async (id) => {
    setUpdateLoader(true);
    var valid = IsValidToUpdate();
    if (valid) {
      let response = await fetch(
        Variables.API_URL + "AlbumItem/UpdateAlbumItem",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            AlbumItemId: updateToDb.AlbumItemId,
            AlbumId: updateToDb.AlbumId,
            ImageUrl: "",
            Title: updateToDb.Title,
            AltText: updateToDb.AltText,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        if (imageTodDb != "") {
          const formData2 = new FormData();
          formData2.append("Image", imageTodDb);
          formData2.append("AlbumItemId", id);
          formData2.append("AlbumId", albumId);

          const resImage = await axios.post(
            Variables.API_URL + "AlbumItem/UploadAlbumItemImage",
            formData2,{
              headers:{
                Authorization: `Bearer ${token}`,
              }
            }
          );
        }

        toast.success("Item Added Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        SetAddModel(false);
        SetUpdateModel(0);
        GetAlbumItems();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("please fill all required fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    setUpdateLoader(false);
  };

  const handleDrop = async (files) => {
    var count = 0;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      if (files[i].size >= 2000000) {
        count = count + 1;
      } else {
        reader.onload = async function () {
          try {
            let response = await fetch(
              Variables.API_URL + "AlbumItem/AddAlbumItem",
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  AlbumItemId: 0,
                  AlbumId: albumId,
                  ImageUrl: "",
                  Title: "",
                  AltText: "",
                }),
              }
            );
            let result = await response.json();
            // console.log("image " + i, files[i]);
            if (response.status === 200) {
              const formData2 = new FormData();
              formData2.append("Image", files[i]);
              formData2.append("AlbumItemId", result);
              formData2.append("AlbumId", albumId);

              const resImage = await axios.post(
                Variables.API_URL + "AlbumItem/UploadAlbumItemImage",
                formData2,{
                  headers:{
                    Authorization: `Bearer ${token}`,
                  }
                }
              );
              GetAlbumItems();
            }
          } catch (ex) {
          }
        };
        reader.readAsDataURL(file);
      }
    }

    if (count === 1) {
      var error1 = " Image is not accepted ";
      toast.error(error1);
    } else if (count > 1) {
      var error2 = count + " Images are not accepted ";
      toast.error(error2);
    }
  };

  useEffect(() => {
   
  

      CheckIfAlbumExist();
  }, []);

  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {albumExist === true && albumDetails.AlbumName}
                  {albumExist === false && "Album Not Exist"}
                  {albumExist === null && "Loading"}
                </h4>
              </div>
              {/* {Permissions.ManageAlbumItems == true && (
                <>
                  <Button variant="primary" onClick={() => SetAddModel(true)}>
                    Add New Item
                  </Button>
                </>
              )} */}
            </Card.Header>

            <Card.Body>
              {Permissions.ManageAlbumItems == true && albumExist == true && (
                <Row>
                  <Col>
                    <Dropzone
                      onDrop={handleDrop}
                      accept="image/jpeg,image/png,image/jpg,image/svg"
                      style={{ height: 100 }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps({ className: "dropzone" })}>
                          <input {...getInputProps()} />
                          <p>Drag'n'drop images, or click to select files</p>
                        </div>
                      )}
                    </Dropzone>
                  </Col>
                </Row>
              )}
              <div className="new-user-info">
                {albumExist === false && (
                  <div className="alert alert-danger" role="alert">
                    Album Not Exist...{" "}
                    <a
                      href="#"
                      className="alert-link"
                      onClick={() => navigate("/album")}
                    >
                      Back To Albums List
                    </a>
                  </div>
                )}

                <Row>
                  {loader ? (
                    <CustomSnipper />
                  ) : (
                    <>
                      <Row className="mt-5">
                        {items.map((data, i) => (
                          <Col
                            key={i}
                            lg="3"
                            md="4"
                            sm="6"
                            className="mb-4 mb-lg-0"
                          >
                            <div
                              className="btn-icon"
                              variant="outline-light"
                              onClick={() => {
                                if (Permissions.ManageAlbumItems) {
                                  setUpdateToDb({
                                    AlbumItemId: data.AlbumItemId,
                                    AlbumId: data.AlbumId,
                                    ImageUrl: data.ImageUrl,
                                    Title: data.Title,
                                    AltText: data.AltText,
                                  });
                                  SetUpdateModel(data.AlbumItemId);
                                }
                              }}
                            >
                              <img
                                src={Variables.imagePath + data.ImageUrl}
                                className="w-100 shadow-1-strong rounded mb-4 sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                            <Modal
                              show={data.AlbumItemId == updateModel}
                              onHide={() => {
                                SetUpdateModel(0);
                                setUpdateToDb({
                                  AlbumItemId: 0,
                                  AlbumId: albumId,
                                  ImageUrl: "",
                                  Title: "",
                                  AltText: "",
                                });
                                setImage("");
                                setImageToDb("");
                              }}
                              size="lg"
                            >
                              <Modal.Header closeButton>
                                <Modal.Title as="h5">
                                  Update Album Item
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                {addLoader === true ? (
                                  <CustomSnipper />
                                ) : (
                                  <>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Title :
                                        </Form.Label>
                                        <Form.Control
                                          id="UpdateTitle"
                                          name="UpdateTitle"
                                          placeholder="Title"
                                          type="text"
                                          value={updateToDb.Title}
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Alt Text :
                                        </Form.Label>
                                        <Form.Control
                                          id="UpdateAltText"
                                          name="UpdateAltText"
                                          placeholder="Alt Text"
                                          type="text"
                                          value={updateToDb.AltText}
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>

                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <div className="mb-3">
                                          <Form.Label
                                            className=""
                                            htmlFor="customFile"
                                          >
                                            Image
                                          </Form.Label>
                                          <Form.Control
                                            id="ImageToUpdate"
                                            name="ImageToUpdate"
                                            placeholder="Image"
                                            type="file"
                                            accept="image/*"
                                            onChange={SetUpdateImage}
                                          />
                                        </div>
                                      </Form.Group>

                                      {imageTodDb !== "" ? (
                                        <div className="col-text-center">
                                          <img
                                            src={image}
                                            className="w-100 shadow-1-strong rounded mb-4 img-200 image-log"
                                            alt="Boat on Calm Water"
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-text-center">
                                          <img
                                            src={
                                              Variables.imagePath +
                                              updateToDb.ImageUrl
                                            }
                                            className="w-100 shadow-1-strong rounded mb-4 img-200 image-log"
                                            alt="Boat on Calm Water"
                                          />
                                        </div>
                                      )}
                                    </Row>
                                  </>
                                )}
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={() => {
                                    setAddToDb({
                                      AlbumItemId: 0,
                                      AlbumId: albumId,
                                      ImageUrl: "",
                                      Title: "",
                                      AltText: "",
                                    });
                                    SetUpdateModel(0);
                                    setImage("");
                                    setImageToDb("");
                                  }}
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="danger"
                                  onClick={() =>
                                    setDeleteModal(data.AlbumItemId)
                                  }
                                >
                                  Delete
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={() => UpdateItem(data.AlbumItemId)}
                                >
                                  Save changes
                                </Button>
                              </Modal.Footer>
                            </Modal>

                            <Modal
                              show={data.AlbumItemId == deleteModal}
                              onHide={() => setDeleteModal(0)}
                            >
                              <Modal.Header closeButton>
                                <Modal.Title as="h5">
                                  Delete Album Item
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                Are you sure do you want to update {data.Title}
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={() => setDeleteModal(0)}
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="danger"
                                  onClick={() => DeleteItem(data.AlbumItemId)}
                                >
                                  Delete
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </Col>
                        ))}
                      </Row>
                    </>
                  )}
                </Row>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Modal
          show={addModel}
          onHide={() => SetAddModel(false)}
          size="lg"
          onHide={() => {
            setAddToDb({
              AlbumItemId: 0,
              AlbumId: albumId,
              ImageUrl: "",
              Title: "",
              AltText: "",
            });
            SetAddModel(false);
            setImage("");
            setImageToDb("");
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title as="h5">Add New Album Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {addLoader === true ? (
              <CustomSnipper />
            ) : (
              <>
                <Row>
                  <Form.Group className="col-md-12 form-group">
                    <Form.Label htmlFor="lname">Title :</Form.Label>
                    <Form.Control
                      id="AddTitle"
                      name="AddTitle"
                      placeholder="Title"
                      type="text"
                      value={addToDb.Title}
                      onChange={handleAddInputs}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="col-md-12 form-group">
                    <Form.Label htmlFor="lname">Alt Text :</Form.Label>
                    <Form.Control
                      id="AddAltText"
                      name="AddAltText"
                      placeholder="Alt Text"
                      type="text"
                      value={addToDb.AltText}
                      onChange={handleAddInputs}
                    />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group className="col-md-12 form-group">
                    <div className="mb-3">
                      <Form.Label className="" htmlFor="customFile">
                        Image
                      </Form.Label>
                      <Form.Control
                        id="ImageToAdd"
                        name="ImageToAdd"
                        placeholder="Image"
                        type="file"
                        accept="image/*"
                        onChange={SetAddImage}
                      />
                    </div>
                  </Form.Group>

                  {image != "" && (
                    <div className="col-text-center">
                      <img
                        src={image}
                        className="w-100 shadow-1-strong rounded mb-4 img-200 image-log"
                        alt="Boat on Calm Water"
                      />
                    </div>
                  )}
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setAddToDb({
                  AlbumItemId: 0,
                  AlbumId: albumId,
                  ImageUrl: "",
                  Title: "",
                  AltText: "",
                });
                SetAddModel(false);
                setImage("");
                setImageToDb("");
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={() => AddNewItem()}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default AlbumItems;
